// const toJSMethods = [
//   'stationIdentityChanged',
//   'audioChanged',
//   'devicesChanged',
//   'gameStarted',
//   'unknownGameStarted',
//   'launcherStarted',
//   'appChanged',
//   'dashboardChanged',
//   'idleChanged',
//   'idleModeChanged',
//   'steamVRChanged',
// ]

// const toCEFMethods = [
//   'startGame',
//   'setDashboard',
//   'forceSetIdle',
//   'setAudio',
//   'stationChanged',
//   'timerChanged',
//   'gamesChanged',
//   'panelsChanged',
//   'quitCurrentApp',
//   'restartBackgroundService',
//   'insertSession',
//   'getAllSessions',
//   'deleteAllSessions',
//   'bookingChanged',
//   'cancelLaunch'
//    notifyAboutCurrentState
// ]

import EventBus from '@/core/shared/services/EventBus';
import store from '@/core/store';
import router from '@/core/routes';
import { InteropNotDefinedError } from '@/core/errors';

const routerReadyPromise = new Promise(resolve => {
  router.onReady(resolve);
});

async function setupInterop () {
  let interopToCEFProxy; // eslint-disable-line
  let CEFBoundPromise = Promise.resolve();
  window.interopToJS = new Proxy(
    {},
    {
      get (target, name) {
        return async payload => {
          await routerReadyPromise;
          // DEPRECATION backward compat with <=4.2.15
          if (
            router.currentRoute.name === 'dashboard:index' ||
            (window.interopToCEF &&
              'notifyAboutCurrentState' in window.interopToCEF &&
              !store.state.launcher.isAppInitialized)
          ) {
            console.warn(
              'interop action dropped because app is not initialized yet',
            );
            return;
          }
          EventBus.$emit('interop', {
            type: 'toJS',
            name,
            payload,
          });
          return store.dispatch(name, payload ? JSON.parse(payload) : payload);
        };
      },
    },
  );
  window._interopToCEF = new Proxy(
    {},
    {
      get (target, name) {
        return async payload => {
          await CEFBoundPromise;
          return interopToCEFProxy[name](payload);
        };
      },
    },
  );
  if (window.sbvrenv.CEFSHARP || window.CefSharp) {
    CEFBoundPromise = window.CefSharp.BindObjectAsync('interopToCEF');
  } else {
    window.interopToCEF = {};
  }
  await CEFBoundPromise;
  interopToCEFProxy = new Proxy(window.interopToCEF, {
    get (target, name) {
      return payload => {
        const fn = target[name];
        const callParams = [];
        if (payload) callParams.push(JSON.stringify(payload)); // CEF Sharp expect a strict argument count
        EventBus.$emit('interop', {
          type: 'toCEF',
          name,
          payload,
        });
        if (!fn) {
          return Promise.reject(
            new InteropNotDefinedError(`interop method ${name} is not defined`),
          );
        }
        return fn
          .apply(this, callParams)
          .then(resp => {
            if (name === 'getStationIdentity') {
              EventBus.$emit('sentry:addBreadcrumb', {
                message: 'getIdentityChangedResp',
                category: 'action',
                data: {
                  payload: resp,
                },
              });
            }
            // parse JSON
            if (resp && resp === Object(resp)) return resp;
            else if (resp) {
              let result;
              try {
                result = JSON.parse(resp);
              } catch (e) {
                result = resp;
              }
              return result;
            }
          })
          .catch(e => {
            console.error(e);
            EventBus.$emit('sentry:captureException', e);
            throw e;
          });
      };
    },
  });
  window._interopToCEF = interopToCEFProxy;
}

setupInterop();
